var map = {
	"./symbol_0.png": 12650,
	"./symbol_1.png": 67859,
	"./symbol_2.png": 22104,
	"./symbol_3.png": 43233,
	"./symbol_4.png": 25518,
	"./symbol_5.png": 54743,
	"./symbol_6.png": 12988,
	"./symbol_7.png": 79525,
	"./symbol_8.png": 1346,
	"./symbol_9.png": 22475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13709;